export default __webpack_public_path__ + "static/media/griffin_interruption.bb28c345.mp4";